import {cloneDeep, forOwn, isArray} from 'lodash';

const SEARCH_TYPE_VIEW_ITEMS = 'items';

const SEARCH_TYPE_VIEW_COLUMNS = 'columns';
const SEARCH_TYPE_VIEW_TITLE_COLUMN = 'titleColumn';
const SEARCH_TYPE_VIEW_COLLECTION_PROPERTY = 'collectionProperty';

const SEARCH_TYPE_VIEW_CAPTION = 'caption';
const SEARCH_TYPE_VIEW_DATA_SOURCES = 'dataSources';
const SEARCH_TYPE_VIEW_REPORTS = 'reports';

const SEARCH_TYPE_VIEW_FILTERS = 'filters';

const SEARCH_TYPE_VIEW_TABS = 'tabs';

export class SearchTypeView {
  constructor(id = undefined, options = {}) {
    this.id = id;
    this.options = options;
  }

  clone() {
    return Object.assign(new SearchTypeView(this.id, this.options), this);
  }

  // eslint-disable-next-line class-methods-use-this
  getType() {
    return undefined;
  }

  getId() {
    return this.id;
  }

  getOptions() {
    return this.options;
  }
}

export class SearchTypeViewItems extends SearchTypeView {
  constructor(rawData = [], id = undefined, options = {}) {
    super(id, options);
    this.rawData = [...rawData];
  }

  clone() {
    return Object.assign(
      new SearchTypeViewItems(cloneDeep(this.rawData), this.id, this.options),
      this
    );
  }

  // eslint-disable-next-line class-methods-use-this
  getType() {
    return SEARCH_TYPE_VIEW_ITEMS;
  }

  getItems() {
    return this.rawData;
  }

  getRawData() {
    return this.rawData;
  }
}

export class SearchTypeViewTables extends SearchTypeView {
  constructor(rawData = {}, id = undefined, options = {}) {
    super(id, options);
    this.rawData = {...rawData};
  }

  clone() {
    return Object.assign(
      new SearchTypeViewTables(cloneDeep(this.rawData), this.id, this.options),
      this
    );
  }

  // eslint-disable-next-line class-methods-use-this
  getType() {
    return SEARCH_TYPE_VIEW_COLUMNS;
  }

  getItems() {
    return this.rawData[SEARCH_TYPE_VIEW_COLUMNS];
  }

  getRawData() {
    return this.rawData;
  }

  getTitleColumn() {
    return this.rawData[SEARCH_TYPE_VIEW_TITLE_COLUMN];
  }

  getCollectionProperty() {
    return this.rawData[SEARCH_TYPE_VIEW_COLLECTION_PROPERTY];
  }
}

export class SearchTypeViewFilters extends SearchTypeView {
  constructor(rawData = {}, id = undefined, options = {}) {
    super(id, options);
    this.rawData = {...rawData};
  }

  clone() {
    return Object.assign(
      new SearchTypeViewFilters(cloneDeep(this.rawData), this.id, this.options),
      this
    );
  }

  // eslint-disable-next-line class-methods-use-this
  getType() {
    return SEARCH_TYPE_VIEW_FILTERS;
  }

  getItems() {
    return this.rawData[SEARCH_TYPE_VIEW_FILTERS];
  }

  getRawData() {
    return this.rawData;
  }
}

export class SearchTypeViewReports extends SearchTypeView {
  constructor(rawData = {}, id = undefined, options = {}) {
    super(id, options);
    this.rawData = {...rawData};
  }

  clone() {
    return Object.assign(
      new SearchTypeViewReports(cloneDeep(this.rawData), this.id, this.options),
      this
    );
  }

  initGeneratedLayout(generatedLayout) {
    this.generatedLayout = generatedLayout;
    return generatedLayout;
  }

  // eslint-disable-next-line class-methods-use-this
  getType() {
    return SEARCH_TYPE_VIEW_REPORTS;
  }

  getItems() {
    return this.rawData[SEARCH_TYPE_VIEW_REPORTS];
  }

  getDataSources() {
    return this.rawData[SEARCH_TYPE_VIEW_DATA_SOURCES];
  }

  getRawData() {
    return this.rawData;
  }

  getGeneratedLayout() {
    return this.generatedLayout;
  }

  getCaption() {
    return this.rawData[SEARCH_TYPE_VIEW_CAPTION];
  }
}

export class SearchTypeViewTabs extends SearchTypeView {
  constructor(rawData = {}, id = undefined, options = {}) {
    super(id, options);
    this.rawData = {...rawData};
  }

  clone() {
    return Object.assign(
      new SearchTypeViewTabs(cloneDeep(this.rawData), this.id, this.options),
      this
    );
  }

  // eslint-disable-next-line class-methods-use-this
  getType() {
    return SEARCH_TYPE_VIEW_TABS;
  }

  getItems() {
    return this.rawData[SEARCH_TYPE_VIEW_TABS];
  }

  getRawData() {
    return this.rawData;
  }
}

export class SearchTypeViews {
  static initViews(rawViews, options = {}) {
    const views = {};
    forOwn(rawViews, (view, id) => {
      if (isArray(view)) {
        views[id] = new SearchTypeViewItems(view, id, options);
      } else if (view[SEARCH_TYPE_VIEW_FILTERS]) {
        views[id] = new SearchTypeViewFilters(view, id, options);
      } else if (view[SEARCH_TYPE_VIEW_COLUMNS]) {
        views[id] = new SearchTypeViewTables(view, id, options);
      } else if (view[SEARCH_TYPE_VIEW_REPORTS]) {
        views[id] = new SearchTypeViewReports(view, id, options);
      } else if (view[SEARCH_TYPE_VIEW_TABS]) {
        views[id] = new SearchTypeViewTabs(view, id, options);
      }
    });
    return views;
  }

  constructor(rawData = {}, options = {}) {
    this.rawData = {...rawData};
    this.options = options;
    this.views = {};
    this.loaded = false;
    if (this.rawData) {
      this.views = SearchTypeViews.initViews(this.rawData, options);
    }
  }

  clone() {
    return Object.assign(
      new SearchTypeViews(cloneDeep(this.rawData), cloneDeep(this.options)),
      this
    );
  }

  getViews() {
    return this.views;
  }

  getView(id) {
    return this.getViews()[id];
  }

  isLoaded() {
    return this.loaded;
  }
}

export default {SearchTypeView, SearchTypeViews};
